{
  "version": "25.9.0-dev.1",
  "id": "at.softline.schuberth.softline",
  "name": "Schuberth Softline"
}
